<template>
  <div class="bg">
    <div class="banner"></div>
    <div class="good-block">
      <p class="title">我们的优势</p>
      <p class="title-en">OUR STRENGTHS</p>
      <i class="nav"></i>
      <div class="good-flex">
        <div class="flex-div">
          <img class="flex-img" src="../../assets/img/taobao/004.png" alt />
          <p class="flex-title">大额优惠</p>
          <p class="flex-subtitle">比直接在淘宝购买便宜</p>
        </div>
        <div class="flex-div">
          <img class="flex-img" src="../../assets/img/taobao/002.png" alt />
          <p class="flex-title">商品丰富</p>
          <p class="flex-subtitle">品类齐全、更新快</p>
        </div>
        <div class="flex-div">
          <img class="flex-img" src="../../assets/img/taobao/003.png" alt />
          <p class="flex-title">海量内容</p>
          <p class="flex-subtitle">拥有淘宝海量小视频和图文</p>
        </div>
      </div>
    </div>
    <div class="contact-us">
      <div class="left">
        <img src="../../assets/img/home/contact.png" alt class="contact-img" />
        <div class="contact-content">联系我们</div>
      </div>
      <div class="middlel">
        <p>广 告 业 务 合 作：+86-15817208249 张小姐</p>
        <p>商 务 合 作 邮 箱： zhangzongkun@gm825.com</p>
        <p>媒 体 垂 询： pr@gm825.com</p>
        <p>市 场 合 作 邮 箱： mkt@gm825.com</p>
      </div>
      <div class="right">
        <p>北 京 地 址： 北京市朝阳区安立路60号润枫德尚苑6号楼4层</p>
        <p>深 圳 地 址：深圳市南山区海天一路15号软件产业基地5栋D6层601A</p>
        <p>玩咖欢聚：www.wankacn.com</p>
        <p>万咖壹联: www.wankaonline.com</p>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  created() {}
};
</script>
<style scoped lang="scss">
.good-block {
  width: 100%;
  height: 540px;
  background-color: white;

  .good-flex {
    position: relative;
    margin: 50px auto 15px auto;
    width: 980px;
    height: 240px;
    display: flex;
    justify-content: space-around;
  }

  .flex-div {
    width: 220px;
    height: 220px;
    border: 1px solid rgba(222, 222, 222, 1);
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }
  .flex-img {
    width: 72px;
    height: 72px;
  }

  .flex-title {
    margin-top: 15px;
    font-size: 28px;
    text-align: center;
    font-weight: bold;
    color: rgba(51, 51, 51, 1);
  }
  .flex-subtitle {
    text-align: center;
    margin-top: 20px;
    font-size: 16px;
    font-weight: 600;
    color: rgba(0, 122, 255, 1);
  }
}
.bg {
  width: 100%;
  height: 100%;
  font-family: Noto Sans S Chinese;
  .banner {
    position: relative;
    width: 100%;
    height: 439px;
    background: url("../../assets/img/taobao/banner.png") no-repeat;
    background-size: cover;
    background-position: center;
    .bannerBox {
      position: absolute;
      height: 130px;
      width: 662px;
      left: 0;
      right: 0;
      top: 0;
      bottom: 0;
      margin: auto;
      .title {
        width: 685px;
        text-align: center;
        display: inline-block;
        font-size: 48px;
        font-weight: 900;
        color: rgba(255, 255, 255, 1);
        line-height: 30px;
        span {
          font-weight: 200;
        }
      }
      .content {
        width: 675px;
        margin-top: 38px;
        font-size: 16px;
        font-weight: 400;
        color: rgba(255, 255, 255, 1);
        line-height: 30px;
        text-align: center;
      }
    }
  }

  .title {
    position: relative;
    padding-top: 90px;
    font-size: 36px;
    text-align: center;
    font-weight: bold;
    color: rgba(51, 51, 51, 1);
  }
  .title-en {
    position: relative;

    // height: 11px;
    text-align: center;
    margin-top: 10px;
    font-size: 14px;
    font-weight: 400;
    color: rgba(153, 153, 153, 1);
  }
  .nav {
    position: relative;

    width: 34px;
    height: 5px;
    display: block;
    margin: 14px auto 0px auto;
    background: rgba(0, 122, 255, 1);
  }
  .introduce {
    height: 1020px;
    background-color: #f7f6fd;
    .bg-block {
      position: absolute;
      background: url("../../assets/img/home/statistics.png") no-repeat;
      background-size: cover;
      width: 100%;
      height: 241px;
    }

    .firstBox {
      position: relative;

      background: url("../../assets/img/home/content-bg.png") no-repeat;
      margin: 15px auto 15px auto;
      // padding: 73px 75px 67px 93px;
      width: 1006px;
      height: 241px;
      line-height: 30px;
      font-size: 16px;
      font-weight: 400;
      color: rgba(102, 102, 102, 1);
      text-indent: 28px;

      .first-img {
        width: 256px;
        height: 170px;
        padding: 36px;
      }
      .first-content {
        width: 750px;
        padding-left: 220px;
        height: 200px;
        font-size: 14px;
        font-weight: 400;
        padding-top: 40px;
        color: rgba(102, 102, 102, 1);
      }
    }
    .secondBox {
      background: url("../../assets/img/home/content-bg2.png") no-repeat;
      margin: 15px auto 15px auto;
      // padding: 73px 75px 67px 93px;
      width: 1006px;
      height: 241px;
      line-height: 30px;
      font-size: 16px;
      font-weight: 400;
      color: rgba(102, 102, 102, 1);
      text-indent: 28px;

      .second-img {
        width: 256px;
        height: 170px;
        padding: 36px;
      }
      .second-content {
        margin-right: -50px;
        padding: 40px 0px 55px 35px;
        width: 750px;
        height: 200px;
        font-size: 14px;
        font-weight: 400;
        color: rgba(102, 102, 102, 1);
      }
    }
    .thirdContentBox {
      background: url("../../assets/img/home/content-bg.png") no-repeat;
      margin: 15px auto 15px auto;
      // padding: 73px 75px 67px 93px;
      width: 1006px;
      height: 241px;
      line-height: 30px;
      font-size: 16px;
      font-weight: 400;
      color: rgba(102, 102, 102, 1);
      text-indent: 28px;

      .third-img {
        width: 256px;
        height: 170px;
        padding: 36px;
      }
      .third-content {
        width: 750px;
        padding-left: 220px;
        height: 200px;
        font-size: 14px;
        font-weight: 400;
        padding-top: 40px;
        color: rgba(102, 102, 102, 1);
      }
    }
  }
  .contact-us {
    width: 100%;
    display: flex;
    flex-direction: row;
    justify-content: center;
    height: 310px;
    background: rgba(33, 36, 51, 1);
    color: white;
    line-height: 32px;
    .left {
      padding-top: 90px;
      flex-grow: 6;
      height: 123px;
      text-align: right;
      .contact-img {
        margin-right: 7px;
      }
      .contact-content {
        height: 100%;
        font-size: 24px;
        font-weight: bold;
        color: rgba(255, 255, 255, 1);
        line-height: 30px;
      }
    }
    .middlel {
      flex-grow: 2;
      padding-top: 60px;
      margin-left: 71px;
      height: 195px;
      font-size: 14px;
      font-weight: 400;
      color: rgba(98, 102, 118, 1);
      line-height: 30px;
      p {
        padding-bottom: 28px;
      }
    }
    .right {
      flex-grow: 6;
      padding-top: 60px;
      height: 195px;
      font-size: 14px;
      font-weight: 400;
      color: rgba(98, 102, 118, 1);
      line-height: 30px;
      p {
        padding-bottom: 28px;
      }
    }
  }
}
</style>
